import { Select } from "@mantine/core";
import { UserPermissionGuard } from "components";
import { useGetBuyspacesQuery } from "modules/buyspaces";
import { Feature, IBuyspace } from "types";

type BuyspaceSelectProps = {
  accountId: string;
  buyspaceId: string | null;
  error?: string;
  maxWidth?: string;
  onChange: (buyspaceId: string | null) => void;
  width?: string;
};

const defaultSelectOption = [{ label: "All Buyspaces", value: "" }];

const BuyspaceSelect = ({ accountId, buyspaceId, onChange, error }: BuyspaceSelectProps) => {
  const { data: buyspaces } = useGetBuyspacesQuery({ id: accountId });

  const createBuyspacesSelectData = (buyspacesData: IBuyspace[] | undefined) => {
    if (!buyspacesData) return [];

    const sortedOptions = [...buyspacesData].sort((a, b) => +a.isAutomatic - +b.isAutomatic);

    return sortedOptions.map(({ name, id, isAutomatic }) => ({
      label: `${name}${isAutomatic ? "*" : ""}`,
      value: id,
      style: {
        wordBreak: "normal"
      }
    }));
  };

  const selectData = [...defaultSelectOption, ...createBuyspacesSelectData(buyspaces?.data)];

  return (
    <UserPermissionGuard module={Feature.BUYSPACES_MODULE} excludeExternal>
      <Select
        placeholder="...Loading Buyspaces"
        readOnly={false}
        size="lg"
        data={selectData}
        error={error}
        value={buyspaceId ? buyspaceId : ""}
        onChange={onChange}
        disabled={!accountId}
      />
    </UserPermissionGuard>
  );
};

export default BuyspaceSelect;
